import { Component, OnInit, ViewChild } from '@angular/core';
import { SignatureBox, SignatureBoxFilter, SignatureDocument, SignatureStatusEnum } from '../../../model/signatureDocumentUsers';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SignatureBoxDataSource } from 'src/app/model/signatureDataSource';
import { SignatureDocumentsService } from '../../../services/signatureDocuments.service';
import { SpinnerService } from '../../../services/spinner.service';
import { Subject, takeUntil } from 'rxjs';
import { SignatureEditSignersComponent } from '../signature-edit-signers/signature-edit-signers.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocumentListEnum } from '../../../utils/documentListUtils';
import { ProtocolQEditGenerateReportComponent } from '../../qualificates/protocol-edit/protocol-q-edit-generate-report/protocol-q-edit-generate-report.component';
import { ProtocolQService } from '../../../services/protocolQ.service';
import { ExecutionQService } from '../../../services/executionQ.service';
import { ExecutionQEditGenerateReportComponent } from '../../qualificates/execution-edit/execution-q-edit-generate-report/execution-q-edit-generate-report.component';

@Component({
    selector: 'app-signature-box',
    templateUrl: './signature-box.component.html',
    styleUrls: ['./signature-box.component.scss'],
    standalone: false,
})
export class SignatureBoxComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  hasFiltered = false;
  dataSource: SignatureBoxDataSource;
  filter: SignatureBoxFilter = new SignatureBoxFilter();

  displayedColumns = ['documentCode', 'client', 'fullName', 'countUser', 'status', 'regDate', 'type', 'edit', 'download'];

  private destroy$ = new Subject<void>();

  constructor(private signatureDocumentsService: SignatureDocumentsService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private protocoQlService: ProtocolQService,
    private executionQService: ExecutionQService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.loadSignatureBox();
  }

  cancel() {

  }

  doFilter(event: SignatureBoxFilter): void {
    this.filter = event;

    this.hasFiltered = true;

    this.loadSignatureBox();
  }

  loadSignatureBox(): void {
    this.dataSource = new SignatureBoxDataSource(this.signatureDocumentsService);

    this.filter.sortBy = this.sort.active || 'documentCode';
    this.filter.sortDirection = this.sort.direction || 'desc';
    this.filter.pageIndex = this.paginator?.pageIndex || 0;
    this.filter.pageSize = this.paginator?.pageSize || 10;
    if (this.hasFiltered) {
      //this.saveSearchFilter(this.filter);
      this.dataSource.loadSingatureBox(this.filter);
    }
    this.dataSource.loading$.pipe(takeUntil(this.destroy$)).subscribe(message => this.spinnerService.next(message));
  }

  openDialogSigner(doc: SignatureBox) {
    const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idDocument: doc.idDocument,
        documentType: doc.idType,
        nDocument: doc.documentCode,
        idClient: doc.idClient,
        inactive: !doc.active
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {

      }
    });
  }

  getTypeDocument(type: number): string {
    if (type === DocumentListEnum.PROTOCOL_QUALIFICATES) {
      return this.translate.instant('signatureDocument.type.protocol');
    } else if (type === DocumentListEnum.EXECUTION_QUALIFICATES) {
      return this.translate.instant('signatureDocument.type.executionQualification');
    }
  }

  getColorStatus(idStatus: number): string {
    switch (idStatus) {
      case SignatureStatusEnum.CANCELLED:
        return 'red';
      case SignatureStatusEnum.SIGNED:
        return 'green';
      default:
        break;
    }
  }

  downloadPdf(box: SignatureBox): void {
    this.spinnerService.show();
    switch (box.idType) {
      case DocumentListEnum.PROTOCOL_QUALIFICATES:
        this.protocoQlService.findOne(box.idDocument).pipe(takeUntil(this.destroy$)).subscribe(result => {
          const protocol = result;
          this.spinnerService.hide();

          this.dialog.open(ProtocolQEditGenerateReportComponent, {
            minWidth: '20%',
            maxHeight: '95vh',
            data: { protocol }
          });
        });
        case DocumentListEnum.EXECUTION_QUALIFICATES:
        this.executionQService.findOne(box.idDocument).pipe(takeUntil(this.destroy$)).subscribe(result => {
          const execution = result;
          this.spinnerService.hide();

          this.dialog.open(ExecutionQEditGenerateReportComponent, {
            minWidth: '20%',
            maxHeight: '95vh',
            data: { execution }
          });
        });
      default:
        break;
    }
  }
}
